import { Component, ElementRef, NgZone, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { MessageModalService } from '../../services/message-modal/message-modal.service';
import { AuthService } from '../../services/auth/auth.service';
import { ButtonComponent } from '../../shared/button/button.component';

@Component({
  selector: 'app-license-agreement',
  standalone: true,
  imports: [ButtonComponent],
  templateUrl: './license-agreement.component.html',
  styleUrl: './license-agreement.component.css',
})
export class LicenseAgreementComponent {
  @ViewChild('eulaFrame') frameRef!: ElementRef<HTMLIFrameElement>;

  eulaRead = false;

  constructor(
    private router: Router,
    private authService: AuthService,
    private messageModal: MessageModalService,
    private ngZone: NgZone
  ) {}

  handleAccept(): void {
    // AuthService broadcasts a user-data refresh on success (the token isn't
    // rotated by EULA acceptance), so UserService re-fetches on its own.
    this.authService.submitEulaAcceptance().subscribe({
      next: () => {
        this.router.navigate(['/home']);
      },
      error: () => {
        this.messageModal.openModal('Error', $localize`Failed to submit the agreement, please try again.`);
      },
    });
  }

  onFrameLoad(): void {
    const contentWindow = this.frameRef.nativeElement.contentWindow;

    contentWindow?.addEventListener('scroll', () => {
      // Account for browser differences in pixel arithmetic with a fudge factor
      const pixelRoundingErrorFactor = 4;
      // Add the vertical scroll position to the frame height. When this is >= the overall content height, the entire document has been scrolled through
      const scrolledToBottom =
        contentWindow.scrollY + contentWindow.innerHeight >=
        contentWindow.document.body.scrollHeight - pixelRoundingErrorFactor;
      if (scrolledToBottom) {
        // this event listener is attached to the iframe's window context, outside Angular's change detection zone
        // wrap in ngZone.run to get normal change detection and updates from this callback
        this.ngZone.run(() => (this.eulaRead = true));
      }
    });
  }
}
